import React, { useState } from 'react';
import { Box, Typography, makeStyles } from '@material-ui/core';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import GroupIcon from '@material-ui/icons/Group';
import SupportModal from '../Layout/SupportModal';
import './HelpCenter.scss';

const useStyles = makeStyles(theme => ({
  primaryContrastText: {
    color: theme.palette.primary.contrastText,
  },
  teamContainer: {
    marginTop: theme.spacing(1),
    padding: theme.spacing(1, 2),
  },
  collapsedIcon: {
    marginBottom: theme.spacing(1),
  },
}));

const HelpCenter = ({ expanded }) => {
  const classes = useStyles();
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <Box className={`${classes.primaryContrastText} ${expanded ? '' : 'd-flex align-items-center flex-column'} help-center`}>
      {expanded ? (
        <Box className={`${classes.teamContainer} team-container`} onClick={() => setModalOpen(true)}>
          <Typography variant="h6" className='contact-text'>Contact Covr</Typography>
          <ArrowForwardIosIcon className='ml-auto' fontSize="small" />
        </Box>
      ) : (
        <Box className={classes.collapsedIcon} onClick={() => setModalOpen(true)}>
          <GroupIcon />
        </Box>
      )}
      <SupportModal open={modalOpen} handleClose={() => setModalOpen(false)} />
    </Box>
  );
};

export default HelpCenter;



// WEBPACK FOOTER //
// ./src/components/HelpCenter/HelpCenter.js